import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import analyticsDashboard from './analyticsDashboard.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import calendar from './calendar.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import chatRooms from './chatRooms.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import contactImport from './contactImport.json';
import conversation from './conversation.json';
import crm from './crm.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import multipleFunnels from './multipleFunnels.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import webphone from './webphone.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import kanbanReports from './kanbanReports.json';
import remarketing from './remarketing.json';

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...analyticsDashboard,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...calendar,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...chatRooms,
  ...components,
  ...contact,
  ...contactFilters,
  ...contactImport,
  ...conversation,
  ...crm,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...multipleFunnels,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...contentTemplates,
  ...webphone,
  ...mfa,
  ...kanbanReports,
  ...remarketing,
};
